const ROUTES = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  // Analytic
  ANALYTIC_GLOBAL_COMMON: "/analytic/global/common",
  ANALYTIC_GLOBAL_USERS: "/analytic/global/users",
  ANALYTIC_CASINO_GAMES: "/analytic/casino/games",
  ANALYTIC_CASINO_PROVIDERS: "/analytic/casino/providers",
  ANALYTIC_SPORTS_CATEGORIES: "/analytic/sports/categories",
  ANALYTIC_SPORTS_COMPETITIONS: "/analytic/sports/competitions",
  ANALYTIC_PAYMENTS_METHODS: "/analytic/payments/methods",
  ANALYTIC_PAYMENTS_PROVIDERS: "/analytic/payments/providers",
  ANALYTIC_PAYMENTS_DEPOSITS: "/analytic/payments/deposits",
  ANALYTIC_GAMES: "/analytic/casino/games",
  ANALYTIC_PROVIDERS: "/analytic/casino/providers",
  // Logs
  LOGS_LIST_ERROR: "/logs/errors",
  LOGS_LIST_WARNINGS: "/logs/warnings",
  LOGS_LIST_NOTICE: "/logs/notices",
  // Risk
  RISK_LIST_PERMISSIONS: "/risk/permissions",
  RISK_LIST_LIMITS: "/risk/limits",
  RISK_LIST_PLAYERS: "/risk/players",
  RISK_LIST_KYC_DOCUMENTS: "/risk/kyc/documents",
  RISK_LIST_KYC_PRESETS: "/risk/kyc/presets",
  RISK_LIST_KYC_RULES: "/risk/kyc/rules",
  // Payments
  PAYMENT_PROVIDERS: "/payments/psp/providers",
  PAYMENT_METHODS: "/payments/psp/methods",
  PAYMENT_OPERATIONS: "/payments/transactions/operations",
  PAYMENT_DEPOSITS: "/payments/transactions/deposits",
  PAYMENT_WITHDRAWALS: "/payments/transactions/withdrawals",
  PAYMENT_COMPENSATION: "/payments/transactions/compensation",
  PAYMENT_COMPENSATIONS: "/payments/transactions/compensations",
  PAYMENT_CONFISCATION: "/payments/transactions/confiscation",
  PAYMENT_CONFISCATIONS: "/payments/transactions/confiscations",
  PAYMENT_CURRENCIES: "/payments/currencies",
  // NOTIFICATIONS
  NOTIFICATIONS_PUSH_AUTO: "/notifications/push/manual",
  NOTIFICATIONS_PUSH_MANUAL: "/notifications/push/auto",
  NOTIFICATIONS_EMAIL_AUTO: "/notifications/email/auto",
  // ROLES
  ROLES_LIST: "/roles/list",
  // GAME CENTER
  GAME_CENTER_GAMES_LIST_NEW: "/game-center/games/new",
  GAME_CENTER_GAMES_LIST_ACTIVE: "/game-center/games/active",
  GAME_CENTER_GAMES_LIST_HIDDEN: "/game-center/games/hidden",
  GAME_CENTER_GAMES_LIST_DEACTIVETED: "/game-center/games/deactivated",
  GAME_CENTER_GAMES_LIST_NO_CATEGORY: "/game-center/games/no-category",
  GAME_CENTER_COLLECTIONS_LIST: "/game-center/collections",
  GAME_CENTER_MULTI_SCOPE_LIST: "/game-center/multi-scope",
  GAME_CENTER_CATEGORIES_LIST: "/game-center/categories",
  GAME_CENTER_TAGS_LIST: "/game-center/tags",
  GAME_CENTER_PROVIDERS_LIST: "/game-center/provider",
  GAME_CENTER_PARSING: "/game-center/parsing",
  // CMS
  CMS_WIDGETS_MAIN_PAGE: "/cms/widgets/main-page",
  CMS_WIDGETS_CASINO_PAGE: "/cms/widgets/casino-page",
  CMS_WIDGETS_LIVE_CASINO_PAGE: "/cms/widgets/live-casino",
  CMS_WIDGETS_BURGER_MENU: "/cms/widgets/burger-menu",
  CMS_WIDGETS_MOBILE_MENU: "/cms/widgets/mobile-menu",
  CMS_WIDGETS_SIGN_UP: "/cms/widgets/sign-up-form",
  CMS_WIDGETS_PRE_DEPOSIT_FORM: "/cms/widgets/pre-deposit-form",
  CMS_WIDGETS_PROFILE_MENU: "/cms/widgets/profile-menu",
  CMS_WIDGETS_GAME_BAR: "/cms/widgets/game-bar",
  CMS_WIDGETS_HEADER: "/cms/widgets/header",
  CMS_WIDGETS_FOOTER: "/cms/widgets/footer",
  CMS_BANNERS_LIST: "/cms/banners",
  CMS_PAGES_LIST: "/cms/pages/list",
  CMS_PAGES_SEO: "/cms/pages/seo",
  CMS_PAGES_FAQ: "/cms/pages/faq",
  CMS_PROMO_LIST: "/cms/promo",
  CMS_FOOTER_PARTNERS: "/cms/footer/partners",
  CMS_FOOTER_SOCIAL_NETWORKS: "/cms/footer/social-networks",
  CMS_FOOTER_APPLICATIONS: "/cms/footer/applications",
  CMS_FOOTER_MAIN_TEXT: "/cms/footer/main-text",
  CMS_FOOTER_PAYMENTS: "/cms/footer/payments",
  CMS_FOOTER_BRANDCORE: "/cms/footer/brand-core",
  CMS_FOOTER_MAIN_TEXT_GET_LOCALE: "/cms/footer/main-text/translation",
  CMS_FOOTER_MAIN_TEXT_SET_LOCALE: "/cms/footer/main-text/set-translation",
  CMS_CUSTOMIZED_LIST: "/cms/customized",
  // Segments
  SEGMENTS_MANUAL: "/players/segments/manual",
  SEGMENTS_AUTO: "/players/segments/auto",
  // Players
  PLAYERS_LIST: "/players/list",
  PRESETS_LIST: "/players/presets",
  // Live ops
  WAGERS_LIST: "/live-ops/wager-games/list",
  WAGERS_GAMES_LIST: "/live-ops/wager-games/not-processing",
  BONUSES_LIST: "/live-ops/bonuses/list",
  BONUSES_GAMES_LIST: "/live-ops/bonuses/free-spins",
  LOYALTY_LEVELS_LIST: "/live-ops/loyalty-program/levels",
  LOYALTY_BETS_POINTS_LIST: "/live-ops/loyalty-program/bets-points",
  LOYALTY_DEPOSIT_POINTS_LIST: "/live-ops/loyalty-program/deposit-points",
  LOYALTY_DEPOSIT_POINTS_LIMITS_LIST: "/live-ops/loyalty-program/deposit-points-limits",
  LOYALTY_SIGN_UP_POINTS_LIST: "/live-ops/loyalty-program/sign-up-points",
  LOYALTY_WAGER_POINTS_LIST: "/live-ops/loyalty-program/wager-points",
  CASHBACKS_LIST: "/live-ops/cashbacks",
  TOURNAMENTS_LIST: "/live-ops/tournaments",
  PROMOCODES_BONUSES_LIST: "/live-ops/promocodes/bonuses",
  CASHBACK_GAMES_LIST: "/live-ops/cashback-games/list",
  CASHBACK_GAMES_LIST_GAMES: "/live-ops/cashback-games/not-processing",
  // Domains
  DOMAINS_ZONES: "/domains/zones",
  DOMAINS_MIRRORS: "/domains/mirrors",
  DOMAINS_COUNTRIES: "/domains/countries",
  //Support
  SUPPORT_TREADS: "/support/threads",
  SUPPORT_CHANNELS: "/support/channels",
  //Scheduler
  SCHEDULER_LIST: "/scheduler/list",
};

export default ROUTES;
